import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import * as css from 'styles'
import styled from '@emotion/styled'
import preventWidowedWords from 'utils/preventWidowedWords'

import { Meta, FadeIn, Grid, Loading } from 'components'
import PageNav from 'app/browse/PageNav'
import Layout from 'layouts/Default'
import ArticleThumbnail from './ArticleThumbnail'

const Articles = (props) => {
  const { articles: { data, status }, location } = useSelector(store => store)

  useEffect((args) => {
    if (status === 'Success') window.prerenderReady = true;
  }, [status])

  return (
    <>
    <Layout>
      <Meta
        title={`Articles`}
        description={`From artist interviews, to guidelines, find useful articles in and around the world of Art in Res.`}
      />

      <ContentLayout>

        <Loading status={status} style={{height: '80vh'}}>

          {data.category ? (
            <header>
              <Meta
                title={data.category.title || 'Articles'}
                description={data.category.public_description || `From artist interviews, to guidelines, find useful articles in and around the world of Art in Res.`}
              />

              <FadeIn delay="200ms">
                <h1>{data.category.title}</h1>
              </FadeIn>
              {data.category.public_description && (
                <FadeIn delay="350ms">
                  <p>{data.category.public_description}</p>
                </FadeIn>
              )}
            </header>
          ) : (
            <header>
              <FadeIn delay="200ms">
                <h1>Articles</h1>
              </FadeIn>
              <FadeIn delay="350ms">
                <p>Every week find new curations, studio visits, interviews and more.  Learn how to choose art you will love, and learn about our artists.</p>
              </FadeIn>
            </header>

          )}
        
          <ArticlesGrid columns="1fr 1fr" gap="5em">
            {data.articles.map((article, i)=>(
              <ArticleThumbnail index={i} key={article.slug} {...article}/>
            ))}
          </ArticlesGrid>

          <div style={{ paddingTop: '1em' }}>
            <PageNav key="nav-bottom" location={location} data={data} status={status}></PageNav>
          </div>

        </Loading>

      </ContentLayout>
    </Layout>
    </>
  )
}

const ContentLayout = styled('div')({
  padding: '2em 0',

  '& header': {
    textAlign: 'center',
    marginBottom: '2em',
  },

  '& p':{
    fontSize: '1.2em', 
    lineHeight: '1.2em',
    maxWidth: '500px',
    margin: '0 auto',
    textAlign: 'center',
    marginBottom: '2em',
  },
})

export const ArticlesGrid = styled(Grid)({
  maxWidth: '1000px',
  margin: '0 auto',
  marginBottom: '7em',

  '& article':{
    // alignItems: 'none !important',
    display: 'block',
  },

  [css.breakpoint.m_up]:{
    '& > article:nth-of-type(2n)':{
      position: 'relative',
      top: '5em',
      // marginTop: '5em',
    },
    
    '& > article:nth-of-type(4n+3)': {
      position: 'relative',
      left: '-1em',
    },

    '& > article:nth-of-type(4n+4)': {
      position: 'relative',
      left: '-1em',
    },
  }
})

export default Articles